export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col justify-center items-center overflow-hidden pt-20 pb-16 lg:pt-24 lg:pb-20 bg-white">
      <div className="relative z-10 w-full max-w-[1100px] mx-auto px-6 flex flex-col items-center text-center">

        <h1 className="font-heading font-bold text-[#1d1d1f] leading-[1.08] tracking-tight mb-5" style={{ fontSize: 'clamp(2rem, 3.8vw, 3.2rem)' }}>
          Рекрутинг і HR <br />для виробничої мережі:<br className="hidden sm:block" />
          <span style={{ color: '#F96B25' }}>від кандидата до працівника</span><br />в одній системі
        </h1>

        <p className="text-gray-500 text-lg lg:text-xl font-normal leading-relaxed max-w-[640px] mb-8 lg:mb-12">
          Масовий найм у 3 рази швидше, звіти без таблиць, інтеграція з ERP та іншими обліковими системами.
          Для заводів, складів, фабрик, агровиробництва, харчового виробництва та логістичних компаній, які наймають масово й постійно.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 mb-14 lg:mb-20">
          <button
            onClick={() => { window.location.href = "https://hurma.work/request-2/?utm_source=industry"; }}
            className="inline-flex items-center justify-center gap-2 bg-[#F96B25] hover:bg-[#e05a14] text-white font-medium text-base px-8 py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Отримати розрахунок і демо
          </button>
          <button
            onClick={() => document.getElementById('solution')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center justify-center gap-2 border border-gray-300 text-gray-600 hover:text-gray-900 hover:bg-gray-100 font-medium text-base px-8 py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Як це працює
            <i className="ri-arrow-right-line text-xs"></i>
          </button>
        </div>

        {/* Logo marquee */}
        <div className="w-full max-w-[960px] mx-auto mb-12 lg:mb-16 overflow-hidden" style={{ maskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)' }}>
          <div className="flex gap-10 lg:gap-14 animate-marquee w-max items-center">
            {[
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/52a8ce8b-8613-4577-a73d-fbf7417010ee_compressed_general.webp', alt: 'General', width: 168 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/349edcd8-2e8c-4e61-a8e1-1c3f60d99df7_compressed_viyar.webp', alt: 'Viyar', width: 144 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/6cb03d7b-246f-4a13-a30d-fae22e746603_compressed_roshen.webp', alt: 'Roshen', width: 168 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/1fff4f8f-4dd3-45e5-8c9a-827b903d24b6_compressed_argroprosperis.webp', alt: 'Agro Prosperis', width: 144 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/ab2044a8-ad7e-4f13-a20e-0ad7b37226b8_compressed_agromat.webp', alt: 'Agromat', width: 168 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/266e4fb5-3228-4eb1-872a-dce9a4a33e87_compressed_sunsey.webp', alt: 'Sunsey', width: 144 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/f05ffc61-1601-43fc-934e-91d7988707b8_compressed_gunia.webp', alt: 'Gunia', width: 144 },
            ].concat([
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/52a8ce8b-8613-4577-a73d-fbf7417010ee_compressed_general.webp', alt: 'General', width: 168 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/349edcd8-2e8c-4e61-a8e1-1c3f60d99df7_compressed_viyar.webp', alt: 'Viyar', width: 144 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/6cb03d7b-246f-4a13-a30d-fae22e746603_compressed_roshen.webp', alt: 'Roshen', width: 168 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/1fff4f8f-4dd3-45e5-8c9a-827b903d24b6_compressed_argroprosperis.webp', alt: 'Agro Prosperis', width: 144 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/ab2044a8-ad7e-4f13-a20e-0ad7b37226b8_compressed_agromat.webp', alt: 'Agromat', width: 168 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/266e4fb5-3228-4eb1-872a-dce9a4a33e87_compressed_sunsey.webp', alt: 'Sunsey', width: 144 },
              { src: 'https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/f05ffc61-1601-43fc-934e-91d7988707b8_compressed_gunia.webp', alt: 'Gunia', width: 144 },
            ]).map((logo, i) => (
              <span
                key={i}
                className="flex items-center justify-center flex-shrink-0 select-none"
                style={{ width: logo.width }}
              >
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-12 lg:h-14 w-full object-contain"
                />
              </span>
            ))}
          </div>
        </div>

        {/* Dashboard */}
        <div className="w-full max-w-[960px] mx-auto rounded-[32px] shadow-2xl overflow-hidden">
          <img
            src="https://storage.helloreaddy.io/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/2d7665d6-d07a-42c8-8e85-ccaac5843eec_compressed_laptop_mockup_44.webp"
            alt="HURMA — дашборд рекрутингової системи"
            className="w-full h-auto object-cover object-top block"
          />
        </div>
      </div>
    </section>
  );
}